import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartPanelService {

  constructor() { }

  public show_panel = false;
  public editCart = false;

  public cartSubject = new Subject<any>();
  public totalCartSubject = new Subject<any>();
  public deleteCartSubject = new Subject<boolean>();
  public userZipCode = new Subject<any>();

  showCartPanel(){
    this.show_panel = true
  }

  setCartSubject(data){
    this.cartSubject.next(data);
  }

  setTotalCartSubject(data = 0){
    this.totalCartSubject.next(data);
  }

  setCheckOutEvent(isEvent = false){
    this.cartSubject.next(isEvent);
  }

 setDeleteCartSubject(isDeleted = false){
    this.deleteCartSubject.next(isDeleted);
 }

 getDeleteCartSubject(){
   return this.deleteCartSubject.asObservable();
 }

  getCartSubject(){
    return this.cartSubject.asObservable();
  }

  getTotalCartSubject(){
    return this.totalCartSubject.asObservable();
  }

  hideCartPanel(){
    this.show_panel = false;
  }

  setUserZipCode(zip_code){
    this.userZipCode.next(zip_code);
  }

  getUserZipCode(){
    return this.userZipCode.asObservable();
  }

}
